import { createAsyncThunk } from "@reduxjs/toolkit";
import { VERIFYEMAIL_API_URL } from "@custom/constant";
import { EmailVerificationFormTypes } from "../../Auth/helper/auth";

const verifyEmailApi = createAsyncThunk('login', async (emailVerificationData: EmailVerificationFormTypes) => {
  const response = await fetch(VERIFYEMAIL_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(emailVerificationData),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Login failed');
  }
  return data;
});

export default verifyEmailApi;
